import { AncillaryManagerFormData, GuidIdAndLabel, GuidIdCodeAndLabel } from '../../../integrated-client/models';

export interface IAncillariesManagerEditorData {
  ancillariesManagerEditorData: AncillaryManagerFormData;
  validation?: any;
}

export class AncillariesManagerEditorData implements IAncillariesManagerEditorData {
  ancillariesManagerEditorData: AncillaryManagerFormData;
  validation?: any;

  constructor() {
    this.ancillariesManagerEditorData = {};
  }
}
